import { FormGroup, Input, Label } from "reactstrap";
import { handleFormChange } from "../../../components/modals/EditableTable";
import { useTranslation } from "react-i18next";

const STATUS_OPTIONS = [
  {
    value: "drop_driver",
    labelKey: "containerSettings.statusDeposit",
    descKey: "containerSettings.statusDepositDesc",
  },
  {
    value: "remove_driver_exchange",
    labelKey: "containerSettings.statusRemoval",
    descKey: "containerSettings.statusRemovalDesc",
  },
  {
    value: "collect",
    labelKey: "containerSettings.statusCollect",
    descKey: "containerSettings.statusCollectDesc",
  },
];

const ZoneSettingsStatut = ({ formData, setFormData }) => {
  const { t } = useTranslation();
  const currentStatus = formData.status ?? "unknown";

  return (
    <div className="zone-settings__statut flex flex-col w-full">
      <FormGroup className="mb-0">
        {STATUS_OPTIONS.map((opt) => (
          <div key={opt.value} className="zone-settings__radio-row">
            <div className="zone-settings__radio-wrap">
              <Input
                type="radio"
                name="status"
                id={`status-${opt.value}`}
                value={opt.value}
                checked={currentStatus === opt.value}
                onChange={(e) => handleFormChange(e, formData, setFormData)}
                className="zone-settings__radio"
              />
            </div>
            <div className="flex-1 min-w-0">
              <Label
                htmlFor={`status-${opt.value}`}
                className="zone-settings__radio-label"
              >
                {t(opt.labelKey)}
              </Label>
              <p className="zone-settings__radio-desc">{t(opt.descKey)}</p>
            </div>
          </div>
        ))}
      </FormGroup>
    </div>
  );
};

export default ZoneSettingsStatut;
